module.exports = __webpack_public_path__ + "img/higgs_module_content2_1_left.2fcc0fce.png";